import { render, staticRenderFns } from "./ConsentPreview.vue?vue&type=template&id=788c25f8&scoped=true"
import script from "./ConsentPreview.vue?vue&type=script&lang=js"
export * from "./ConsentPreview.vue?vue&type=script&lang=js"
import style0 from "./ConsentPreview.vue?vue&type=style&index=0&id=788c25f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c25f8",
  null
  
)

export default component.exports